var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrequalShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#2566B0",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#2566B0",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.6667L18 19.3334V23.3334C18 27.0334 20.56 30.4934 24 31.3334C27.44 30.4934 30 27.0334 30 23.3334V19.3334L24 16.6667ZM24 23.9934H28.6667C28.3133 26.7401 26.48 29.1867 24 29.9534V24.0001H19.3333V20.2001L24 18.1267V23.9934Z",
    fill: "#2566B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrequalShield);
export default __webpack_public_path__ + "static/media/prequal_shield.e962fb5a.svg";
export { ForwardRef as ReactComponent };